import React from "react"
import { Link } from "@reach/router"
import { withTheme } from "styled-components"

export interface HomeLinkProps {
  fg?: string
  theme: any
  [rest: string]: any
}

const HomeLink = ({ fg = "black", theme, ...rest }: HomeLinkProps) => (
  <Link
    {...rest}
    getProps={({ isCurrent }) => {
      return {
        style: {
          color: isCurrent ? theme.colors[fg] : null
        }
      }
    }}
  />
)

export default withTheme(HomeLink)
